import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './religion.reducer';

export const ReligionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const religionEntity = useAppSelector(state => state.religion.entity);
  const loading = useAppSelector(state => state.religion.loading);
  const updating = useAppSelector(state => state.religion.updating);
  const updateSuccess = useAppSelector(state => state.religion.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/religion${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.christian !== undefined && typeof values.christian !== 'number') {
      values.christian = Number(values.christian);
    }
    if (values.buddhist !== undefined && typeof values.buddhist !== 'number') {
      values.buddhist = Number(values.buddhist);
    }
    if (values.hindu !== undefined && typeof values.hindu !== 'number') {
      values.hindu = Number(values.hindu);
    }
    if (values.jewish !== undefined && typeof values.jewish !== 'number') {
      values.jewish = Number(values.jewish);
    }
    if (values.muslim !== undefined && typeof values.muslim !== 'number') {
      values.muslim = Number(values.muslim);
    }
    if (values.sikh !== undefined && typeof values.sikh !== 'number') {
      values.sikh = Number(values.sikh);
    }
    if (values.otherReligion !== undefined && typeof values.otherReligion !== 'number') {
      values.otherReligion = Number(values.otherReligion);
    }
    if (values.noReligion !== undefined && typeof values.noReligion !== 'number') {
      values.noReligion = Number(values.noReligion);
    }
    if (values.religionNotStated !== undefined && typeof values.religionNotStated !== 'number') {
      values.religionNotStated = Number(values.religionNotStated);
    }

    const entity = {
      ...religionEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...religionEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.religion.home.createOrEditLabel" data-cy="ReligionCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.religion.home.createOrEditLabel">Create or edit a Religion</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="religion-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.religion.geographicLevel')}
                id="religion-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.religion.date')}
                id="religion-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.geography')}
                id="religion-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.geographyCode')}
                id="religion-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.totalAllUsualResidents')}
                id="religion-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.christian')}
                id="religion-christian"
                name="christian"
                data-cy="christian"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.buddhist')}
                id="religion-buddhist"
                name="buddhist"
                data-cy="buddhist"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.hindu')}
                id="religion-hindu"
                name="hindu"
                data-cy="hindu"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.jewish')}
                id="religion-jewish"
                name="jewish"
                data-cy="jewish"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.muslim')}
                id="religion-muslim"
                name="muslim"
                data-cy="muslim"
                type="text"
              />
              <ValidatedField label={translate('apiLocationApp.religion.sikh')} id="religion-sikh" name="sikh" data-cy="sikh" type="text" />
              <ValidatedField
                label={translate('apiLocationApp.religion.otherReligion')}
                id="religion-otherReligion"
                name="otherReligion"
                data-cy="otherReligion"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.noReligion')}
                id="religion-noReligion"
                name="noReligion"
                data-cy="noReligion"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.religion.religionNotStated')}
                id="religion-religionNotStated"
                name="religionNotStated"
                data-cy="religionNotStated"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/religion" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReligionUpdate;
